import styled from '@emotion/styled';
import { Typography } from 'components/Typography';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const AskProductOrderListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-top: ${pxToEm(28)};
`;

export const ProjectName = styled(Typography)`
  margin-left: ${pxToEm(16)};
  margin-bottom: ${pxToEm(12)};
  margin-top: ${pxToEm(12)};
  color: ${palette.grey['A400']};
  word-break: break-word;
`;

const getCompactStyles = (compact?: boolean) => {
  if (compact) {
    return `
      flex-direction: row;
      gap: ${pxToEm(12)};
      border-top: 1px solid ${palette.grey['50']};
      padding-top: ${pxToEm(12)};
      padding-bottom: ${pxToEm(24)};
    `;
  } else {
    return `
      flex-direction: column;
      gap: 0;
      border-top: none;
      padding-top: 0;
    `;
  }
};

export const OrderList = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  ${({ compact }) => getCompactStyles(compact)}
`;
